import MediaQueries from "../../utils/MediaQueries";

const activeTopBarClass = "mobile-top-bar--open",
    fixedTopBarClass = "mobile-top-bar--fixed",
    activeBottomBarClass = "mobile-bottom-bar--open",
    followNavbarShareClass = "share--follow-navbar";

export default {

    handleMobileScroll(scrollY, lastScrollY, $topBar, $bottomBar, $shareButton) {

      let totalHeight = $(document).height() - $(window).height();

        if (scrollY === 0) {

            $topBar.removeClass(fixedTopBarClass);

            if (MediaQueries.isFullScreen()) {
                $bottomBar.addClass(activeBottomBarClass);
                $shareButton.addClass(followNavbarShareClass);
            }
        }
        if (scrollY + 10 < lastScrollY && scrollY > 300 || scrollY === totalHeight) {

          if (MediaQueries.isFullScreen()) {
            $bottomBar.addClass(activeBottomBarClass);
            $shareButton.addClass(followNavbarShareClass);
          }
          $topBar.addClass(activeTopBarClass);
          $topBar.addClass(fixedTopBarClass);

        } else if (scrollY - 10 > lastScrollY && !$(".panel-wrapper").hasClass("panel-wrapper--open")) {

            if (MediaQueries.isFullScreen()) {
                $bottomBar.removeClass(activeBottomBarClass);
                $shareButton.removeClass(followNavbarShareClass);
            }

            if (scrollY > 300) {
                $topBar.removeClass(activeTopBarClass);
            }
        }
    }

}



// IOS Fix
// To avoid the double scrolling problem, we need to
// prevent touchmoves in multiple cases

var windowHeight = $("#mobile-menu-rubric .panel__body").height();

$(".panel").each(function() {

  $(this).find(".categories").each(function() {

    let _overlay = $(this)[0];
    let _clientY = null; // remember Y position on touch start

    let disableRubberBand = function(event) {

      let clientY = event.targetTouches[0].clientY - _clientY;
      let topOffset = $(this).find(".panel__body").scrollTop();

      // console.log("clientY", clientY , "target clientY", event.targetTouches[0].clientY, "panelscrollTop", _overlay.scrollTop);
      console.log("isTotallyScrolled", isOverlayTotallyScrolled());
      console.log("scrollHeight", _overlay.scrollHeight, "scrollTop", topOffset, "clientHeight", windowHeight);
      if (topOffset === 0 && clientY > 0) {
        console.log("top is reached");
        event.preventDefault();
      }
      if (isOverlayTotallyScrolled(topOffset, windowHeight) && clientY < 0) {
        console.log("bottom is reached");
        event.preventDefault();
      }
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    let isOverlayTotallyScrolled = function(topOffset) {
      return _overlay.scrollHeight - topOffset <= windowHeight;
    }

    _overlay.addEventListener('touchstart', function (event) {
      // detect single touch
      if (event.targetTouches.length === 1)
        _clientY = event.targetTouches[0].clientY;
    }, false);

    _overlay.addEventListener('touchmove', function (event) {
      // detect single touch
      if (event.targetTouches.length === 1)
        disableRubberBand(event);
    }, false);

  });

});

// Be sure that the top and bottom bar are not scrollable
// This can cause a scroll behind the menu on IOS
$("#mobile-bottom-bar, #mobile-top-bar, .panel__head, .mobile-bottom-bar__list").on("touchmove", function(e) {
  e.preventDefault();
});



// WEBPACK FOOTER //
// ./js/navbar/mobile/NavbarScroll.js